module.exports = __webpack_public_path__ + "static/media/arrow.857ef74b.svg";